"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Tooltips
 */
var React = require("react");
var react_tooltip_lite_1 = require("react-tooltip-lite");
var types_1 = require("../configuration/types");
/**
 * Specific JSX.Element tag types that can be used as the target.
 * The element that is inserted as a target will have this tag type.
 */
var targetTags;
(function (targetTags) {
    targetTags["td"] = "td";
    targetTags["div"] = "div";
    targetTags["span"] = "span";
})(targetTags = exports.targetTags || (exports.targetTags = {}));
/**
 * OUI tooltip component v2
 */
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, className = _a.className, targetTag = _a.targetTag;
    return (React.createElement(types_1.OuiConfigurationContextConsumer, null, function (_a) {
        var portalClass = _a.portalClass;
        return (React.createElement(react_tooltip_lite_1.default, { tagName: targetTag || targetTags.span, content: React.createElement("div", { className: "oui-tooltip__labs oui-text-default-line-height" }, content), direction: "up-start", distance: 5, padding: "0", arrow: false, className: className, tipContentClassName: portalClass || "", tipContentHover: true }, children));
    }));
};
exports.default = Tooltip;
//# sourceMappingURL=Labs.Tooltip.js.map